import { Alert, Button, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

import MainInformation from '@Components/ComposedComponents/MainInformation';
import PublishingDates from '@Components/ComposedComponents/PublishingDates';
import SEOInformation from '@Components/ComposedComponents/SEOInformation';
import CopyrightInformation from '@Components/ComposedComponents/CopyrightInformation';
import LinksAndAttachments from '@Components/ComposedComponents/LinksAndAttachments';

const backButtonStyle = {
	width: 200,
	padding: '5px 10px',
	borderRadius: '100px',
};

export default function PhotoReadOnlyForm(props) {
	const navigate = useNavigate();

	return (
		<>
			<Alert
				message="Content cannot be modified from the Multimedia Centre CMS."
				description="If you wish to edit any content, this must be done via submitting the corresponding file. To unpublish this content, simply click the 'Delete' button for the corresponding ID in the CMS."
				type="info"
				showIcon
			/>
			<br /><br />
			<MainInformation readOnly {...props} />
			<br /><br />
			<SEOInformation {...props} />
			<br /><br />
			<PublishingDates {...props} />
			<br /><br />
			<CopyrightInformation {...props} />
			<br /><br />
			<LinksAndAttachments {...props} />
			<br /><br />
			<Row justify="center">
				<Col>
					<Button
						onClick={() => navigate(-1)}
						type="default"
						size="large"
						style={backButtonStyle}
					>
						GO BACK
					</Button>
				</Col>
			</Row>
		</>
	);
}
